/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';
import { BatchView        } from '@/screens/ide/batchviewer/batch.view';

/**
 *
 * @class BatchViewerMetadata
 *
 * @brief meta data for viewing a batch; at a minimum you need to provide the scalable work engine (SWE)
 * batch id.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class BatchViewerMetadata extends DocumentMetadata {

  /** the scalable work engine (SWE) batch id */
  public batchId: string = '';

  /** the name of the batch */
  public name: string    = '';

  /** the folder where the batch is stored */
  public root: string    = '';

  /** the viewing mode (monitor is the one where you track live progress) */
  public mode: BatchView = BatchView.EDIT;

  /** standard constructor */
  constructor(
    id:          string     = '',
    title:       string     = '',
    batchId:     string     = '',
    name:        string     = '',
    root:        string     = '',
    mode:        BatchView  = BatchView.EDIT,
    icon:        string     = '<i class="fa fa-th"></i>',
    type:        WindowType = WindowType.BatchViewer,
  ) {

    super(id, title, icon, type);

    this.batchId = batchId;
    this.name    = name;
    this.root    = root;
    this.mode    = mode;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({batchId: this.batchId, name: this.name, root: this.root, mode: this.mode});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.batchId = node.batchId;
    this.name    = node.name;
    this.root    = node.root;
    this.mode    = node.mode;
  }
}
